import { normalizedStreams } from './utils';

const createState = () => ({
  active: false,
  muted: true,
  playing: false,
  buffering: false,
  liveStreaming: null,
  streams: null,
  volume: 10,
  duration: Infinity,
  currentTime: 0,
  action: {},
  error: null,
  autounmute: true,
});

const state = createState();

/* eslint-disable no-param-reassign, no-shadow */
const actions = {
  volumeUp: ({ state, commit }) => {
    if (state.volume < 10) {
      commit('setVolume', state.volume + 1);
    }
  },
  volumeDown: ({ state, commit }) => {
    if (state.volume > 0) {
      commit('setVolume', state.volume - 1);
    }
  },
  changePosition: ({ commit }, value) => {
    commit('setAction', { name: 'changePosition', value });
  },
  rewindBack: ({ commit }) => {
    commit('setAction', { name: 'rewind', value: -1 });
  },
  rewindForward: ({ commit }) => {
    commit('setAction', { name: 'rewind', value: 1 });
  },
};

const mutations = {
  setVolume(state, volume) {
    state.volume = volume;
  },
  setActive(state, active) {
    state.active = active;
  },
  setMuted(state, muted) {
    state.muted = muted;
  },
  setPlaying(state, playing) {
    state.playing = playing;
  },
  setBuffering(state, buffering) {
    state.buffering = buffering;
  },
  setLiveStreaming(state, liveStreaming) {
    state.liveStreaming = liveStreaming;
  },
  setStreams(state, streams) {
    state.error = null;
    state.streams = normalizedStreams(streams);
  },
  setDuration(state, duration = Infinity) {
    state.duration = duration;
  },
  setCurrentTime(state, time) {
    state.currentTime = time;
  },
  setAction(state, action) {
    state.action = action;
  },
  setError(state, error) {
    if (Boolean(state.error) === Boolean(error)) return; // prevent multiple setError by MediaPlayer
    state.error = error;
  },
  resetPlayback(state) {
    Object.assign(state, createState());
  },
  setAutounmute(state, val) {
    state.autounmute = val;
  },
};

const getters = {
  playerState: (state) => {
    if (!state.streams?.length) return 'empty';
    if (state.error) return 'error';
    if (state.buffering) return 'buffering';
    return state.playing ? 'playing' : 'pause';
  },

  isCurrentStream: state => url => state.streams.some(({ src }) => src === url),

  /* liveStreaming property allows to set streaming type externally
     since it's not always possible to define this using duration
     (duration can be NaN if a stream is not supported or finite number for some live streams) */
  isLiveStream: state => state.duration === Infinity || state.liveStreaming,
  isFiniteAudio: state => state.duration !== Infinity && state.duration > 0,
};
/* eslint-enable no-param-reassign, no-shadow */

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
